<template lang="html">

  <article class="col-33" @click="sendToShow">
    <div class="img-video" :style="`background:url(${data.snippet.thumbnails.medium.url}) center/cover no-repeat`">
      <a class="play"></a>
    </div>
    <a class="link-video" v-html="data.snippet.title"></a>
  </article>

</template>

<script lang="js">
  export default  {
    name: 'video-el',
    props: ['data'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
      sendToShow : function(){
        this.$emit('show', this.data.id.videoId);
      }
    },
    computed: {

    }
  }
</script>

<style scoped>
.video-el {

}
</style>



// WEBPACK FOOTER //
// src/components/parts/video-el.vue